export default "__VITE_ASSET__CuMjXHK6__";